import { render, staticRenderFns } from "./LoadingScreen.vue?vue&type=template&id=6273e21c&scoped=true"
import script from "./LoadingScreen.vue?vue&type=script&lang=js"
export * from "./LoadingScreen.vue?vue&type=script&lang=js"
import style0 from "./LoadingScreen.vue?vue&type=style&index=0&id=6273e21c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6273e21c",
  null
  
)

export default component.exports